import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import PlaceholderComponent from './PlaceholderComponent';

/**
 * Custom TipTap extension for placeholder tokens
 * Renders placeholders as non-editable inline elements with distinct styling
 * Validates: Requirements 3.2, 3.4
 */
const PlaceholderExtension = Node.create({
  name: 'placeholder',
  
  group: 'inline',
  
  inline: true,
  
  atom: true,
  
  addAttributes() {
    return {
      token: {
        default: null,
        parseHTML: element => element.getAttribute('data-token'),
        renderHTML: attributes => {
          if (!attributes.token) {
            return {};
          }
          return {
            'data-token': attributes.token,
          };
        },
      },
      label: {
        default: null,
        parseHTML: element => element.getAttribute('data-label'),
        renderHTML: attributes => {
          if (!attributes.label) {
            return {};
          }
          return {
            'data-label': attributes.label,
          };
        },
      },
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'span[data-placeholder]',
      },
    ];
  },
  
  renderHTML({ node, HTMLAttributes }) {
    // Output the token (e.g., {{contact.first_name}}) in the HTML
    // This is what the backend expects for placeholder replacement
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-placeholder': 'true',
        'data-token': node.attrs.token,
        'data-label': node.attrs.label,
        class: 'placeholder-token',
        contenteditable: 'false',
      }),
      node.attrs.token, // Use token instead of label for backend processing
    ];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(PlaceholderComponent);
  },
  
  addCommands() {
    return {
      insertPlaceholder: (attributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes,
        });
      },
    };
  },
});

export default PlaceholderExtension;
